import {
  RouteListItemButtonLink,
  type RouteListItemButtonLinkProps,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import ListItemButton from "@mui/material/ListItemButton";

export interface HybridRouteListItemButtonLinkProps
  extends RouteListItemButtonLinkProps {
  name: string;
  caption: string;
  isReact?: boolean;
  url: string;
}

export const HybridRouteListItemButtonLink: React.FC<
  HybridRouteListItemButtonLinkProps
> = ({ url, isReact = true, children, ...rest }) => {
  // Temporary disable React Router DOM link because Rails with React don't correctly handle the link
  if (!isReact || window.reactWithRails) {
    return (
      <ListItemButton component="a" href={url} {...rest}>
        {children}
      </ListItemButton>
    );
  }

  return (
    <RouteListItemButtonLink to={url} {...rest}>
      {children}
    </RouteListItemButtonLink>
  );
};
